import { Fade } from "./Fade";

export function TrustedBy() {
  return (
    <section className="border-y border-white/[0.06] py-10 px-5 sm:px-8 md:px-10">
      <div className="max-w-[1280px] mx-auto">
        <Fade>
          <p className="text-[11px] tracking-[0.15em] uppercase text-white/25 text-center mb-8">
            Trusted by growth teams at
          </p>
        </Fade>
        <Fade delay={0.1}>
          <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
            {/* TODO: replace with real client logos */}
            {["Agency Alpha", "ScaleUp Co", "MediaLab", "Performance.io", "GrowthHQ"].map((name) => (
              <span
                key={name}
                className="text-sm font-semibold text-white/15 tracking-wide"
              >
                {name}
              </span>
            ))}
          </div>
        </Fade>
      </div>
    </section>
  );
}
